import { render, staticRenderFns } from "./OrderListProduct.vue?vue&type=template&id=45056b7a&scoped=true&"
import script from "./OrderListProduct.vue?vue&type=script&lang=js&"
export * from "./OrderListProduct.vue?vue&type=script&lang=js&"
import style0 from "./OrderListProduct.vue?vue&type=style&index=0&id=45056b7a&prod&lang=css&"
import style1 from "./OrderListProduct.vue?vue&type=style&index=1&id=45056b7a&prod&scoped=true&lang=css&"
import style2 from "./OrderListProduct.vue?vue&type=style&index=2&id=45056b7a&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45056b7a",
  null
  
)

export default component.exports